import React, { useEffect, useState } from "react";
import { getRoles, addRolePermission, getPermission } from "../../Services/MasterService";
import { toast } from "react-toastify";

const AddRolePermission = ({ data, onClose, onCloseWithApi }) => {
    const [reqData, setReqData] = useState({
        resource: "",
        role_id: "",
        permission_id: ""
    });
    const [loader, setLoader] = useState(false);
    const [role, setRole] = useState([]);
    const [permission, setPermission] = useState([]);

    const handleChange = (field, value) => {
        setReqData({ ...reqData, [field]: value })
    };

    const getRolesCall = async () => {
        let { ok, data } = await getRoles({});
        if (ok) {
            setRole(data?.records);
        }
    };

    const getPermissionsCall = async () => {
        let { ok, data } = await getPermission({});
        if (ok) {
            setPermission(data?.records);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const isNotAllowed = Number(reqData?.role_id) + Number(reqData?.permission_id);
        if (isNotAllowed < 2 || isNaN(isNotAllowed)) {
            toast.error("Role and Permission are required")
        } else {
            setLoader(true);
            let { ok } = await addRolePermission(reqData);
            if (ok) {
                toast.success("Success");
                onCloseWithApi();
            }
            setLoader(false);
        }
    };

    useEffect(() => {
        getRolesCall();
        getPermissionsCall();
        if (data?.data) {
            const { resource, role_id, permission_id, id } = data?.data;
            setReqData({ resource, role_id, permission_id, id })
        }
    }, []);

    return (
        <div
            className="modal custom-modal fade bank-details show"
            id="add_items"
            role="dialog"
            aria-modal="true"
            style={{
                display: "block",
                background: "rgb(0 0 0 / 50%)",
            }}
        >
            <form onSubmit={(e) => handleSubmit(e)}>
                <div className="modal-dialog modal-dialog-centered modal-md">
                    <div className="modal-content">
                        <div className="modal-header">
                            <div className="form-header text-start mb-0">
                                <h4 className="mb-0">{!reqData?.id ? "Add Role And Permission" : "Edit Role And Permission"}</h4>
                            </div>
                            <button
                                type="button"
                                className="close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                                onClick={() => onClose()}
                            >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="bank-inner-details">
                                <div className="row">
                                    <div className="col-lg-12 col-md-12">
                                        <div className="form-group">
                                            <label>Resource</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Name"
                                                required
                                                value={reqData?.resource}
                                                onChange={(e) => handleChange("resource", e?.target?.value)}
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label>Role</label>
                                            <select required value={reqData?.role_id} onChange={(e) => handleChange("role_id", e.target.value)} class="form-select" aria-label="Default select example">
                                                <option selected>Select Role</option>
                                                {role?.map(obj =>
                                                    <>
                                                        <option value={obj?.id}>{obj?.name}</option>
                                                    </>
                                                )}
                                            </select>
                                        </div>
                                        <div className="form-group">
                                            <label>Permission</label>
                                            <select required value={reqData?.permission_id} onChange={(e) => handleChange("permission_id", e.target.value)} class="form-select" aria-label="Default select example">
                                                <option selected>Select Permission</option>
                                                {permission?.map(obj =>
                                                    <>
                                                        <option value={obj?.id}>{obj?.name}</option>
                                                    </>
                                                )}
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <div className="bank-details-btn">
                                <button
                                    data-bs-dismiss="modal"
                                    className="btn bank-cancel-btn me-2"
                                    onClick={() => onClose()}
                                    disabled={loader}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="btn bank-save-btn"
                                    disabled={loader}
                                >
                                    {loader ? "Loading..." : "Save"}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    );
};

export default AddRolePermission;